module.exports = __webpack_public_path__ + "static/media/laptop-small-min.73ee0427.webp";